/* Copyright (c) 2016-2023 Planticle Pty Ltd */

import ko from "knockout";
import birdata from "../../../api.js";
import SortableTableViewModel from "../../shared/sortable-table.js";

function ManageEventsHomeViewModel(params) {
	var self = this;

	self.events = ko.observable([]);

	self.status = ko.observable('loading');
	self.error = ko.observable(false);

	self.programs = ko.observable([]);
	birdata.lookup().then(function(lookups) {
		self.programs(lookups.program);
	});

	function update() {
		self.status('loading');
		birdata.events({ can_manage: true }).then(function(events) {
			self.status('loaded');
			self.events(events);
		}).catch(function(error) {
			self.events([]);
			self.error('Failed to load events');
		});
	}

	update();

	self.eventsTable = new SortableTableViewModel([
		{
			name: 'Name',
			sortable: true,
			value: function(event) { return event.name; },
			html: function(event) { return this.value(event); },
			click: function(event, e) {
				return false;
			},
			id: 'name'
		},
		{
			name: 'Created by',
			sortable: true,
			value: function(event) { return event.creator.full_name; },
			html: function(event) { return this.value(event); },
			click: function(event, e) {
				return false;
			},
			id: 'creator'
		},
		{
			name: 'Program',
			sortable: true,
			value: function(event) {
				var program = self.programs().filter(p => p.code == event.program)[0];
				return program ? program.name : event.program;
			},
			html: function(event) { return this.value(event); },
			click: function(event, e) {
				return false;
			},
			id: 'program'
		},
		{
			name: 'Dates',
			sortable: true,
			value: function(event) { return event.start_date + ' to ' + event.finish_date; },
			html: function(event) { return this.value(event); },
			click: function(event, e) {
				return false;
			},
			id: 'dates'
		}
	]);

	self.eventsTable.sortDescriptors([{
		column: 'dates',
		ascending: false
	}]);

	self.clickEvent = function(event) {
		params.parent.viewEventDetails(event.id);
	};

	self.refresh = function() {
		update();
	};

	self.createNewEvent = function() {
		params.parent.createNewEvent();
	}

	self.noResults = ko.pureComputed(function() {
		return self.status() == 'loaded' && self.events().length == 0;
	});

	self.sortedEvents = self.eventsTable.sortedItems(self.events);
}


ko.components.register('manage-events-home', {
	viewModel: function(params) {
		return new ManageEventsHomeViewModel(params);
	},
	template: require('../../../../templates/admin/events/manage-events-home.html')
});
